<template>
  <!-- 위쪽 「지원 접속」 검색(사용자 결정 10-29): 회사 이름 일부·관리자 아이디 앞부분 → 고르면 바로 접속 창 -->
  <div v-if="canSupportEntry" class="support-quick">
    <a-select
      v-model:value="picked"
      show-search
      :filter-option="false"
      :not-found-content="searching ? '찾는 중…' : failed || (query ? '없습니다' : '두 글자 이상')"
      :options="options"
      placeholder="지원 접속: 회사 이름·관리자 아이디"
      style="width: 280px"
      size="small"
      aria-label="지원 접속할 회사 찾기"
      @search="onSearch"
      @select="onSelect"
    />
    <support-entry-dialog
      v-model:open="supportOpen"
      :company-id="supportTarget.id"
      :company-type="supportTarget.type"
      :company-name="supportTarget.name"
    />
  </div>
</template>

<script>
import supportEntryMixin from "@/mixins/supportEntryMixin";
import { errorMessage } from "@/utils/mfa";
import { searchableQuery, targetOptionLabel } from "@/utils/supportAccess";
import { SupportAdminApi } from "@/api/standards";

export default {
  name: "SupportQuickEntry",
  mixins: [supportEntryMixin],
  data() {
    return { picked: undefined, query: "", options: [], found: [], searching: false, failed: "" };
  },
  beforeUnmount() {
    clearTimeout(this.timer);
  },
  methods: {
    // ponytail: 0.3초 멈추면 찾음(키마다 부르지 않게)
    onSearch(text) {
      clearTimeout(this.timer);
      this.query = searchableQuery(text);
      this.failed = "";
      if (!this.query) {
        this.options = [];
        return;
      }
      const q = this.query;
      this.timer = setTimeout(() => this.find(q), 300);
    },
    async find(q) {
      this.searching = true;
      try {
        const found = await SupportAdminApi.findTargets(q);
        if (q !== this.query) return; // 늦게 온 옛 답은 버림
        this.found = found;
        this.options = found.map((c) => ({ value: c._id, label: targetOptionLabel(c) }));
      } catch (error) {
        console.error(error);
        this.options = [];
        // 권한·서버 오류를 「없습니다」로 숨기지 않음(10-29 공용 비밀번호 세션 403 이 「없습니다」로 보였음)
        if (q === this.query) this.failed = errorMessage(error, "찾지 못했습니다. 잠시 뒤 다시 시도하세요.");
      } finally {
        this.searching = false;
      }
    },
    onSelect(id) {
      const c = this.found.find((x) => x._id === id);
      this.picked = undefined;
      if (c) this.openSupport(c, c.type);
    },
  },
};
</script>

<style scoped>
.support-quick {
  display: inline-flex;
  align-items: center;
}
</style>
